<template>
  <div class="home">
    Report
  </div>
</template>

<script>
  export default {}
</script>
